// this was autogenerated by gulpTimezonePlugin from the timezone source in node_modules
(window.__PRELOADED_TIMEZONE_DATA__ || (window.__PRELOADED_TIMEZONE_DATA__ = {}))['da_DK']  = { // eslint-disable-line import/no-commonjs
  name: 'da_DK',
  day: {
    abbrev: ['søn', 'man', 'tir', 'ons', 'tor', 'fre', 'lør'],
    full: [
      'søndag',
      'mandag',
      'tirsdag',
      'onsdag',
      'torsdag',
      'fredag',
      'lørdag'
    ]
  },
  month: {
    abbrev: [
      'jan',
      'feb',
      'mar',
      'apr',
      'maj',
      'jun',
      'jul',
      'aug',
      'sep',
      'okt',
      'nov',
      'dec'
    ],
    full: [
      'januar',
      'februar',
      'marts',
      'april',
      'maj',
      'juni',
      'juli',
      'august',
      'september',
      'oktober',
      'november',
      'december'
    ]
  },
  meridiem: ['', ''],
  date: '%Y-%m-%d',
  time24: '%H:%M:%S',
  dateTime: '%a %e %b %Y %H:%M:%S',
  time12: '',
  full: '%a %b %e %H:%M:%S %Z %Y'
}
